import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=a4e76708&scoped=true"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"
import style0 from "./Pager.vue?vue&type=style&index=0&id=a4e76708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e76708",
  null
  
)

export default component.exports